export default "__VITE_ASSET__BQ90O2gb__"